<template>
  <div>
    <div class="publicvideo" :class="statusvideo == 'add'?'hiddenvideo':''" style="background-color:#F7F8FA ;">
      <div class="public_name">
        视频名称 （{{paramsInfo.videoName}}）
      </div>
      <div class="upgress u-flex u-flex-between u-flex-items-center">
        <div class="video_img">
          <img src="/static/center/videoicon.png" alt="" srcset="">
        </div>
        <div class="caozuoname" style="flex: 1.2;">
          <div class="u-flex u-flex-between u-flex-items-center">
            <span>已经上传：{{videoInfo.size}}Mb/{{videoInfo.allSize}}MB</span>
            <div class="u-flex-items-center u-flex">
              <span  style="margin-right: 20px;color: #721EDC;" v-if="videoUploadPercent == 100">上传成功</span>
              <span style="margin-right: 20px;" v-else>{{videoUploadPercent}}%</span>
              <div @click="switchVideo" class="u-flex u-flex-center u-flex-items-center" style="color: #721EDC;">
                <img style="margin-right: 4px;cursor: pointer;" src="/static/center/reload.png" alt="" srcset="">
                更换视频
              </div>
            </div>
          </div>
          <el-progress v-if="videoFlag" :text-inside="true" :stroke-width="4" :percentage="videoUploadPercent"
            status="success"></el-progress>
        </div>
      </div>
      <div class="setvideoparams">
        <div class="setvideoName">
          基本设置
        </div>
        <div class="u-flex u-flex-between">
          <div class="">
            <div class="edititem  u-flex u-flex-items-start">
              <div class="titles">
                <!-- <span>*</span> -->
                封面
              </div>
              <div class="cntval">
                <el-upload class="handleimg" ref='uploadimg' :action="updateFileImgurl" :headers='headers'
                  :before-upload="beforeAvatarUpload" :show-file-list="false" :on-change='beforeAvatarChange'
                  :on-success="handleAvatarSuccess" :limit='1' list-type="picture-card" :auto-upload="true">
                  <i v-if="!imageUrl" slot="default" class="el-icon-plus"></i>
                  <div class="handleimgHover" v-else slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="imageUrl" alt="">
                    <span class="maskavtar" @click.stop="">
                      <span class="el-upload-list" @click.stop="handlePictureCardPreview(file)">
                        <i style="color: #F7F8FA;" class="el-icon-zoom-in"></i>
                      </span>
                      <span class="el-upload-list" @click.stop="handleRemove(file)">
                        <i style="color: #F7F8FA;" class="el-icon-delete"></i>
                      </span>
                      <!-- <span
                          v-if="!disabled"
                          class="el-upload-list__item-delete"
                          @click="handleDownload(file)"
                        >
                          <i class="el-icon-download"></i>
                        </span> -->

                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="imageUrl" alt="">
                </el-dialog>
              </div>
            </div>
            <div class="edititem u-flex u-flex-items-start">
              <div class="titles u-flex u-flex-items-start">
                <span>*</span>
                内容
              </div>
              <div class="cntval">
                <el-input type="textarea" :maxlength="200" :rows="2" v-model="paramsInfo.videoContent" placeholder="请输入内容">
                </el-input>
              </div>
            </div>
            <div class="edititem  u-flex u-flex-items-center">
              <div class="titles">
                <span>*</span>
                分区
              </div>
              <div class="cntval">
                <el-cascader   :props="{ checkStrictly: false, value:'categoryId',label:'categoryName'}"  v-model="checktabs" @change="handleChange" :options="fromvideo.cascaderlist"  clearable>
                </el-cascader>
              </div>
            </div>
            <div class="edititem  u-flex u-flex-start">
              <div >
                <div class="titles u-flex u-flex-items-center" style="height: 30px;">
                  <span>*</span>
                  标签
                  <el-tooltip  popper-class='popperClass' content="使用活动标签即可参加活动" placement="right-start">
                    <i style="margin-left: 3px;" class="el-icon-warning-outline"> </i>
                  </el-tooltip>
                </div>
              </div>
              <div class="cntval">
                <el-select style="width: 100%;" @change="changetabs" v-model="fromvideo.tagName" multiple filterable allow-create
                  default-first-option placeholder="请选择文章标签">
                  <el-option v-for="(item,index) in fromvideo.taglist" :key="index" :label="item.tagName" :value="item.tagId">
                  </el-option>
                </el-select>

                <div class="pushtabs u-flex">
                  <div class="name">
                    推荐标签：
                  </div>
                  <div class="tablist">
                    <span @click="addtabs(item)" v-for="item in fromvideo.taglist">{{item.tagName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile" v-if="videoInfo.videoUrl && isShowUploadVideo">
            <img src="/static/center/moblie.png" alt="" srcset="">
            <div class="player">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
                :options="playerOptions">
              </video-player>
              <div class="btnxinxin1 video_lookicon">
                <img src="/static/center/xinxin.png" alt="" srcset="">
              </div>
              <div class="btnxinxin2 video_lookicon">
                <img src="/static/center/say.png" alt="" srcset="">
              </div>
              <div class="btnxinxin3 video_lookicon">
                <img src="/static/center/share.png" alt="" srcset="">
              </div>
              <div class="btnxinxin4 video_lookicon">
                <img src="/static/center/tabbar.png" alt="" srcset="">
              </div>
              <div class="btnxinxin5 video_lookicon">
                <img src="/static/center/search.png" alt="" srcset="">
              </div>
              <div class="btnxinxin6 video_lookicon">
                <img src="/static/center/addcare.png" alt="" srcset="">
              </div>
              <div class="btnxinxin7 video_lookicon">

              </div>
            </div>
          </div>
        </div>
        <div class="publicbtn">
          <div  class="lookvideos" @click="saveVideo">草稿</div>
          <div  class="lookvideos" :class="saveLoading?'greyColor':''"  @click="publicVideo">发布</div>
          <!-- <div class="lookvideos" @click="LookVideo">预览</div> -->
        </div>
      </div>
    </div>
    <div class="publicvideo" :class="statusvideo == 'edit'?'hiddenvideo':''">
      <div class="public_name">
        发布视频
      </div>
      <div class="update_video">
        <div class="upvideo">
          <!--             :
           http-request = 'httpRequest'

           -->
          <el-upload action class="upload-demo" drag :action="updateFileurl" :headers='headers' :show-file-list='false'
            :auto-upload='true' :on-change='handleVideoChange' :before-upload="beforeVideorUpload"
            :on-success="handleVideoSuccess" :on-progress="uploadVideoProcess">
            <i class="el-icon-upload" style="font-size: 80px;"></i>
            <div class="el-upload__text"> <em>点击上传</em> 或直接将视频文件拖入此区域</div>
            <div class="miaoshu">
              为了更好的观看体验、超过40秒的视频建议
            </div>
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
        <div class="alertmsg">
          <div class="items_msg">
            <div>
              视频格式
            </div>
            <div class="discript">支持常用视频格式，推荐使用mp4、web、mov</div>
          </div>
          <div class="items_msg">
            <div>
              视频大小
            </div>
            <div class="discript">视频文件大小不超过100M，时长在10分钟以</div>
          </div>
          <div class="items_msg">
            <div>
              视频分辨率
            </div>
            <div class="discript">分辨率为720p（1280x720）以上</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>


  function getNum(){
        var chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
        var nums="";
        for(var i=0;i<32;i++){
        var id = parseInt(Math.random()*61);
        nums+=chars[id];
        }
        return nums;
  }



  import {
    videoPlayer
  } from 'vue-video-player'
  import ROOTURLS from '@/api/lz.js'
  import {
    videoUpload,
    videoSave,
    videoTagList,
    getcategories,
    videoDraftsave
  } from '@/api/video.js'
  export default {
    components: {
      videoPlayer
    },
    created() {
      let {
        statusvideo,
        videoId
      } = this.$route.query;
      console.log('接受参数——上传视频', videoId);
      if (statusvideo) {
        this.statusvideo = statusvideo;
        if(statusvideo =='add'){
          console.log('已清除缓存');
          localStorage.removeItem('editVideInfo');
        }
      }


      this.paramsInfo.idempotence = getNum();


      console.log('随机', this.paramsInfo.idempotence);
      this.initData(videoId);

    },
    watch: {
      // 监听 playTime 有新值 ，然后在进行判断
      playTime: function(newVal) {
        this.option()

      },
    },
    methods: {
      async initData(videoId) {
        let res = await getcategories({})
        console.log('获取视频分类', res);
        if(res.data.code == 200){
          this.fromvideo.cascaderlist = res.data.data
        }
        let result = await videoTagList({})
        console.log('获取标签分类', result);
        if(result.data.code == 200){
         this.fromvideo.taglist = result.data.data
        }

        if(videoId && videoId == -1){
          this.parseQueryFraft()
        }else{
           this.parseQuery()
        }
      },
      parseQueryFraft(){
        // 查询该视频信息
        let VideInfoData = JSON.parse(localStorage.getItem('editVideInfo') || '{}');
        console.log('草稿信息',VideInfoData);
        if(VideInfoData.hasOwnProperty('draftId')){
          let {coverImg,videoContent,videoUrl,videoSize,videoId,videoDuration,videoName,pCategoryId,cCategoryId,draftId} = VideInfoData;
          console.log(videoUrl);
          this.paramsInfo = Object.assign(this.paramsInfo,{coverImg,videoSize,draftId:draftId,videoId:videoId?videoId:'',videoContent,pCategoryId,cCategoryId,videoUrl,videoName})
          this.playTime = videoDuration;
           this.videoUploadPercent = 100
          // 计算总大小
          let allSize = videoSize / 1024 / 1024
          this.videoInfo.allSize = allSize.toFixed(2);
          this.videoInfo.size =  allSize.toFixed(2);
          // 封面
          this.imageUrl = ROOTURLS.ImgpagaUrl  +  coverImg;
          // 分区
          setTimeout(()=>{
            this.checktabs = [pCategoryId,cCategoryId];
            console.log('分区数据', this.checktabs );
          },200)
          let strList = VideInfoData.labelIds.split(",");
           this.fromvideo.tagName = strList.map(item=>item=Number(item))
        }
      },
      // 过滤接口
      parseQuery(){
        // 查询该视频信息
        let VideInfoData = JSON.parse(localStorage.getItem('editVideInfo') || '{}');
        console.log('视频信息',VideInfoData);
        if(VideInfoData.hasOwnProperty('videoInfo')){
          let {videoInfo:{coverImg,videoContent,videoUrl,videoSize,videoId,videoDuration,videoName,pCategoryId,cCategoryId}} = VideInfoData;
          console.log(videoUrl);
          this.paramsInfo = Object.assign(this.paramsInfo,{coverImg,videoSize,draftId:'',videoId:videoId?videoId:'',videoContent,pCategoryId,cCategoryId,videoUrl,videoName})
          this.playTime = videoDuration;
           this.videoUploadPercent = 100
          // 计算总大小
          let allSize = videoSize / 1024 / 1024
          this.videoInfo.allSize = allSize.toFixed(2);
          this.videoInfo.size =  allSize.toFixed(2);
          // 封面
          this.imageUrl =   ROOTURLS.ImgpagaUrl   + coverImg;
          // 分区
          setTimeout(()=>{
            this.checktabs = [pCategoryId,cCategoryId];
            console.log('分区数据', this.checktabs );
          },200)
          this.fromvideo.tagName = []
          VideInfoData.videoLabelRelList.map(item=>{
            if(item.labelId){
              this.fromvideo.tagName.push(item.labelId)
            }
          })


        }
      },
      // 初始化参数
      async initquery(){
        return new Promise(async (resolve,reject)=>{
          let {videoUrl,videoContent,videoSize,coverImg} = this.paramsInfo;
          let videoDuration = this.playTime;
          if(!videoUrl){
            console.log('视频上传有误');
            this.$message.error('视频上传有误');
            reject(false)
            return
          }
          // if(!coverImg){
          //   this.$message.error('请上传视频封面');
          //   reject(false)
          //   return
          // }
          if(!videoContent){
            this.$message.error('请输入视频内容');
            reject(false)
            return
          }

          let keyWord = await  this.$store.dispatch('fifWord',{key:"videoNamelist",value:videoContent})
          if(keyWord.state){
            this.paramsInfo.videoContent= keyWord.value;
          }else{
            return
          }


          if(this.fromvideo.tagName.length==0){
            this.$message.error('请选择标签内容');
            reject(false)
            return
          }
          if(this.checktabs.length==0){
            this.$message.error('请选择分类内容');
            reject(false)
            return
          }
          let [pCategoryId,cCategoryId] = this.checktabs;
          let labelIds = this.fromvideo.tagName.join();
          let obj = {
            pCategoryId,cCategoryId,labelIds,videoDuration,coverImg
          }

          Object.assign(this.paramsInfo,obj);
          resolve(true)
        })

      },
      // 存草稿
      async  saveVideo(){
        if(!this.saveLoading){
          let result =  await  this.initquery();
          console.log('保存参数',this.paramsInfo);
          if(result){
            videoDraftsave(this.paramsInfo).then(res=>{
              console.log('保存结果',res);
              if(res.data.code == 200){

                this.$message.success('已保存到草稿')

                setTimeout(()=>{
                  this.saveLoading = false;
                  this.$emit('stachange',{
                    path:'/centerfraft',
                    query:{id: '1', tab: '1',pagestatus: '/centerfraft'}
                  })
                },200)

              }
            })
          }
          setTimeout(()=>{
            this.saveLoading = false;
          },1000)
        }else{
          this.$message.info('请勿重复发布')
        }
      },
      // 预览
      LookVideo(){
         this.isShowUploadVideo = true;
         console.log('加载玩了',);
         this.$forceUpdate()
         setTimeout(()=>{
           this.$refs.videoPlayer.player.play()
         },200)
      },
      // 发布视频
      async publicVideo(){
        if(!this.saveLoading){
          let result =  await  this.initquery();
          this.saveLoading = true;
          console.log('保存参数',this.paramsInfo);
          if(result){
            videoSave(this.paramsInfo).then(res=>{
              console.log('保存结果',res);
              if(res.data.code == 200){
                this.$message.success('发布成功');
                setTimeout(()=>{
                  this.saveLoading = false;
                  this.$emit('stachange',{
                    path:'/videomanagement',
                    query:{id: '1', tab: '0',pagestatus: '/videomanagement'}
                  })
                },200)
              }
            })
          }

          setTimeout(()=>{
            this.saveLoading = false;
          },1000)
        }else{
          this.$message.info('请勿重复发布')
        }
      },
      handleChange(e){
        console.log(e,this.checktabs);
      },
      // 图片点击
      handlePictureCardPreview(file) {
        this.dialogVisible = true;
      },
      //上传成功回调
      handleVideoSuccess(res, file) {
        //前台上传地址
        if (file.status == 'success') {
          console.log('上传成功！', file, res);
          // 视频名称
          this.paramsInfo.videoName = file.name;
          if(res.code == 200){
            this.videoInfo.videoUrl =  ROOTURLS.ImgpagaUrl  + res.data;
            this.playerOptions.sources[0].src =  this.videoInfo.videoUrl;
            // 视频参数
            this.paramsInfo.videoUrl  = res.data;
            setTimeout(()=>{
              this.LookVideo()
            },1000)
          }
          this.$message.success('上传成功',  this.videoInfo.videoUrl )
          this.videoUploadPercent = 100
        } else {
          this.$message.success("上传失败，请重新上传");
        }
        //后台上传地址
        // if (res.Code == 0) {
        //     this.videoForm.showVideoPath = res.Data;
        // } else {
        //     layer.msg(res.Message);
        // }
      },
      async handleVideoChange(file, fileList) {
          console.log('file上传状态',  );

      },
      //进度条
      uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true;
        this.videoUploadPercent = file.percentage.toFixed(0) * 1;
        let size = file.size / 1024 / 1024;
        this.videoInfo.size = size.toFixed(2);

        console.log('进度条', this.videoUploadPercent);
      },
      handleAvatarSuccess(res, file) {
        console.log('封面上传成功', res);
         if(res.code == 200){
           this.imageUrl = ROOTURLS.ImgpagaUrl   + res.data  // URL.createObjectURL(file.raw);
           this.paramsInfo.coverImg = res.data
         }
      },
      handleRemove(file, fileList) {
        this.imageUrl = ''
        this.$refs.uploadimg.clearFiles()
      },
      beforeAvatarChange(file, fileList) {
        console.log('文件列表', fileList);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      // 上传之前的限制
      async beforeVideorUpload(file) {
        // 计算总大小
        let allSize = file.size / 1024 / 1024
        this.videoInfo.allSize = allSize.toFixed(2);
        // 视频参数大小
        this.paramsInfo.videoSize = file.size;
        let status = true;
        // 文件变量要先存起来
        this.videoInfo.File = file;
        // 限制上传大小
        var fileSize = allSize < 50;
        // 限制上传格式
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
          this.$message.error("请上传正确的视频格式");
         status =  false;
        }
        if (!fileSize) {
          this.$message.error("视频大小不能超过50MB");
         status =  false;
        }

        //获取文件时长

        let result = await new Promise((resolve, rejected) => {
          var content = file;
          //获取录音时长
          var url = URL.createObjectURL(content);
          var audioElement = new Audio(url);
          audioElement.addEventListener("loadedmetadata", (_event) => {
            this.playTime = parseInt(audioElement.duration);
            let allTime = 5*60
            if (this.playTime >  allTime){
              this.$message.error("上传文件时长不能超过5分钟!");
              rejected(false)
            } else {
              // 这里处理合格的上传文件
              this.statusvideo = 'edit';
              this.videoUploadPercent = 0;
              this.videoFlag = true;
              resolve(true)
            }
          });
        })
        console.log('还会继续执行？',result);
        if(!result){
          return false
        }
        return status
      },
      //根据时长判断是否作出限制
      option(file) {
        if (this.playTime >  (5* 60)) {
          this.$message.error("上传文件时长不能超过5分钟!");
          this.fileList = [];
          return false
        }
        // // 这里处理合格的上传文件
        // this.statusvideo = 'edit';
        // this.videoUploadPercent = 0;
        // this.videoFlag = true;
        // this.httpRequest(this.videoInfo.File)
      },
      httpRequest(val) {
        if (this.statusvideo == 'edit') {
          let file = new FormData()
          file.append('file', val)
          // file.append('file', val.file)  // 直接自定义请求
          videoUpload(file).then(res => {
            console.log('上传结果', res)
            if (res.data.code == 200) {
              this.$message.success('上传成功')
              this.videoUploadPercent = 100
            }else{
              this.$message.success(res.data.message?res.data.message:'上传失败！')
            }
          })
        }
      },
      getTimes(file) {

      },
      // 添加标签
      addtabs(val) {
        let arr =  this.fromvideo.tagName.filter(item=>item === val.tagId);
        if(arr.length == 0){
          this.fromvideo.tagName.push(val.tagId)
        }
      },
      // 切换标签
      changetabs(val) {
        console.log(val, this.fromvideo.taglist);
      },
      // 切换视频
      switchVideo(e) {
        this.statusvideo = 'add'
        this.videoFlag = false;
      }
    },
    data() {
      return {
        saveLoading:false,
        checktabs:[],
        paramsInfo: {
          videoId: '',
          videoUrl: '',
          coverImg: '',
          videoName:'',
          idempotence:'',
          videoContent: '',
          videoSize: '',
          videoDuration: '',
          pCategoryId: '',
          cCategoryId: '',
          draftId: '',
          labelIds: '',
        },
        videoInfo: {
          size: 0,
          File: {},
          allSize: 0,
          videoUrl:'',
        },
        fromvideo: {
          content: '',
          videoName:'',
          taglist: [],
          tagName:[],
          cascaderlist: [],
        },
        dialogVisible: false,
        dialogImageUrl: false,
        disabled: false,
        headers: {
          device: 'lz',
          packageId: '1',
          version: '1.0',
          channel: 'pc',
          authToken: localStorage.getItem("token")
        },
        imageUrl: '',
        playTime: '',
        updateFileImgurl: ROOTURLS.FansUpLoadUrl + '/file/videoImgUpload',
        updateFileurl: ROOTURLS.FansUpLoadUrl + '/file/videoUpload',
        videoFlag: true,
        videoUploadPercent: 0,
        isShowUploadVideo: false,
        statusvideo: 'edit',
        playerOptions: {
          //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          controls: false, // 控制栏
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '9:16', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "", // 视频格式
            src: "" //你的m3u8地址（必填）
          }],
          poster: "poster.jpg", //你的封面地址
          width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: false,
            durationDisplay: false,
            remainingTimeDisplay: false,
            fullscreenToggle: false //全屏按钮
          }
        },
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';

  .hiddenvideo {
    opacity: 0;
    height: 0px !important;
    position: relative;
    z-index: -1;
    transition: all .2s;
  }
  .greyColor{
    opacity: .6 !important;
  }
  .publicvideo {
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    width: calc(1200px - 202px);
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow-y: scroll;

    .setvideoparams {
      margin-top: 24px;
      background-color: #fff;
      padding: 24px;

      .publicbtn {
        display: flex;
        justify-content: center;
        margin-top: 80px;
        .lookvideos{
          background: #721EDC;
          margin-left: 30px;
        }
        div {
          width: 180px;
          cursor: pointer;
          text-align: center;
          height: 44px;
          line-height: 44px;
          background: #721EDC;
          color: #fff;
          border-radius: 8px;
        }
      }

      .mobile {
        display: flex;
        align-self: flex-end;
        position: relative;

        .player {
          position: absolute;
          top: 37px;
          bottom: 42px;
          left: 2px;
          right: 2px;

          .btnxinxin1 {
            bottom: 100px;
            right: 12px;
          }

          .btnxinxin2 {
            bottom: 60px;
            right: 12px;
          }

          .btnxinxin3 {
            bottom: 20px;
            right: 12px;
          }

          .video_lookicon {
            position: absolute;
            z-index: 999;

            img {
              width: 20px;
              height: 36px;
            }
          }

          .btnxinxin4 {
            bottom: -40px;
            right: 2px;
            left: 2px;

            img {
              width: 265px;
              height: 35px;
            }
          }

          .btnxinxin5 {
            top: 17px;
            left: 14px;

            img {
              width: 20px;
              height: 20px;
            }
          }

          .btnxinxin7 {
            bottom: 150px;
            right: 4px;
            border: 1px solid rgba(255, 255, 255, .7);
            width: 35px;
            height: 35px;
            border-radius: 50%;

            img {
              width: 35px;
              height: 35px;
            }
          }

          .btnxinxin6 {
            bottom: 147px;
            right: 15px;

            img {
              width: 14px;
              height: 14px;
            }
          }
        }

        img {
          width: 275px;
          height: 566px;
        }
      }

      .edititem {
        margin-top: 24px;

        .popperClass {
          background-color: #fff;
          color: #721EDC;
        }

        .titles {
          margin-right: 40px;
          font-size: 14px;
          display: flex;
          justify-content: flex-start;
          height: 100%;
          max-width: 80px;
          min-width: 60px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;

          span {
            color: #ED1010;
          }
        }

        .cntval {
          max-width: 500px;

          .handleimg {
            /deep/ .el-upload--picture-card {
              height: 200px;
              width: 200px;
              align-items: center;
              justify-content: center;
              align-items: center;
              line-height: 200px;
              background-color: #DADADA;
            }

            height: 200px;
            width: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            .maskavtar {
              position: absolute;
              height: 200px;
              background-color: rgba(0,0,0,.2);
              width: 200px;
              z-index: 12;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 12px;
              overflow: hidden;
              .el-upload-list {
                margin: 0 12px;
                // height: 10px;
              }
            }

            .handleimgHover {
              position: relative;
              z-index: 99;
              height: 200px;
              overflow: hidden;
            }

            img {
              width: 100%;
              z-index: -1;
            }
          }

          /deep/ .el-textarea__inner {
            width: 500px;
            height: 192px;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #DADADA;
          }

          .pushtabs {
            margin-top: 32px;
            display: flex;

            .name {
              min-width: 100px;
              font-size: 14px;
            }

            .tablist {
              span {
                cursor: pointer;
                display: inline-block;
                margin: 0 12px 12px 0;
                padding: 0 12px;
                text-align: center;
                height: 32px;
                line-height: 32px;
                background: #F7F8FA;
                border-radius: 4px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
            }
          }
        }

        // img {
        //   width: 200px;
        //   height: 100px;
        //   border-radius: 8px;
        //   border: 1px solid rgba(0, 0, 0, .1);
        // }
      }

      .setvideoName {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        // margin-bottom: 24px;
        color: #333333;
      }
    }

    .upgress {
      background-color: #fff;
      padding: 0 24px 24px;

      .caozuoname {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .video_img {
        margin-right: 12px;

        img {
          width: 44px;
          height: 44px;
        }
      }
    }



    .public_name {
      padding: 24px;
      background-color: #fff;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    .update_video {
      padding: 0 24px;
      display: flex;
      flex-direction: column;

      /deep/ .el-upload-dragger {
        width: 100% !important;
        height: 100% !important;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: #F7F8FA;
      }

      /deep/ .el-upload {
        width: 100% !important;
        height: 100%;
      }


      .alertmsg {
        display: flex;
        margin-top: 10px;
        margin-bottom: 24px;

        .items_msg {
          width: 308px;
          height: 158px;
          margin-right: 12px;
          background: #F7F8FA;
          border-radius: 8px;
          padding: 24px;
          box-sizing: border-box;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;

          .discript {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-top: 10px;
          }

          font-size: 16px;
          font-family: PingFangSC-Regular,
          PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .items_msg:last-child {
          margin-right: 0 !important;
        }
      }

      .upvideo {
        background: #F7F8FA;
        border-radius: 6px;
        border: 1px solid #DADADA;
        width: 100%;
        height: calc(100vh - 240px - 162px);

        .el-upload__text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
        }

        .miaoshu {
          margin-top: 8px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .upload-demo {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/centeraddVideo.vue